<ion-header>
	<ion-toolbar color="warning">
		<div class="container-header">
			<ion-label class="title text-wrap" translate>Unavailable Items</ion-label>
		</div>
	</ion-toolbar>
</ion-header>

<ion-content class="ion-padding modal-content-scroll">
	<div class="center-div-message">
		<div class="alert-icon-container">
			<img src="assets/icon/warning.svg" alt="Aviso" class="alert-icon">
		</div>
		
		<p class="alert-message" translate>
			Some items from your last order are no longer available in the current menu:
		</p>
		
		<div class="removed-items-list">
			<div *ngFor="let removed of removedItems" class="removed-item">
				<div class="item-name">
					<strong>{{ removed.item.name }}</strong>
				</div>
				<div class="item-reason">
					{{ removed.motivo }}
				</div>
			</div>
		</div>
		
		<p class="info-message" *ngIf="hasValidItems" translate>
			Available items have been added to your cart.
		</p>
	</div>
</ion-content>

<ion-footer>
	<ion-button class="mb-1" color="warning" expand="block" size="small" mode="ios"
		style="--padding-bottom: 5px; --padding-top: 5px; font-weight: 800; font-size: 1.0em;" (click)="dismiss()" translate>
		Got it
	</ion-button>
</ion-footer>

